var _desc, _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconSign(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "110px",
    height: "112px",
    viewBox: "0 0 110 112",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "contract-40-crop") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Checkout-1.0",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "25--Mail-1---Visa-leasingavtalf\\xF6rslag",
    transform: "translate(-974.000000, -238.000000)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3",
    transform: "translate(310.000000, 225.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(660.000000, 9.000000)",
    id: "contract-40-crop"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(4.800000, 4.800000)"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle-2",
    fill: "#005AA0",
    points: "6.49411765 103.905882 6.49411765 6.49411765 77.9294118 6.49411765 77.9294118 38.9647059 84.4235294 38.9647059 84.4235294 0 5.76793515e-15 0 0 110.4 84.4235294 110.4 84.4235294 90.9176471 77.9294118 90.9176471 77.9294118 103.905882"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Line",
    fill: "#DF0314",
    points: "19.4823529 29.2235294 64.9411765 29.2235294 64.9411765 22.7294118 19.4823529 22.7294118"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Line",
    fill: "#DF0314",
    points: "19.4823529 42.2117647 64.9411765 42.2117647 64.9411765 35.7176471 19.4823529 35.7176471"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Line",
    fill: "#DF0314",
    points: "19.4823529 55.2 64.9411765 55.2 64.9411765 48.7058824 19.4823529 48.7058824"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Line",
    fill: "#DF0314",
    points: "19.4823529 68.1882353 48.7058824 68.1882353 48.7058824 61.6941176 19.4823529 61.6941176"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.3926623,46.1543882 L58.4932123,83.0538381 L58.4932123,87.6458727 L63.085247,87.6458727 L99.9846969,50.7464228 L95.3926623,46.1543882 Z M65.7751986,94.1399904 L64.4302228,94.1399904 L51.9990947,94.1399904 L51.9990947,80.3638865 L95.3926623,36.9703189 L109.168766,50.7464228 L65.7751986,94.1399904 Z",
    id: "Line",
    fill: "#005AA0"
  }))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSign);
export default __webpack_public_path__ + "static/media/icon_sign.2ec983ca3f2eadab9f4e084f0bb283c5.svg";
export { ForwardRef as ReactComponent };